
/**
 * Feature Flag Initialization
 * 
 * This file contains code to initialize feature flags when the application starts.
 * It allows us to set default values for feature flags.
 */

import { setFeatureFlag, FeatureFlag, getAllFeatureFlags } from './featureFlags';

// Initialize feature flags with default values
export function initializeFeatureFlags() {
  // Log the start of initialization
  console.log('Initializing feature flags with default values...');
  
  // Force enable all feature flags to ensure the application works correctly
  const featureFlags: FeatureFlag[] = [
    'enable_new_api_layer',
    'enable_react_query',
    'enable_new_auth',
    'enable_new_stripe_webhook',
    'enable_sms'
  ];
  
  // Force set all flags to true
  featureFlags.forEach(flag => {
    setFeatureFlag(flag, true);
    localStorage.setItem(`feature_flag_${flag}`, 'true');
    console.log(`Feature flag ${flag} set to true`);
  });
  
  // Log all feature flags after initialization
  console.log('All feature flags initialized:', getAllFeatureFlags());
}
